import React from "react";

const IconSource = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="16" cy="16" r="15.75" stroke="#B2BCC6" strokeWidth="0.5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.93972 9.16699C9.52132 9.16699 9.18214 9.50278 9.18214 9.91699V12.917C9.18214 13.3312 9.52132 13.667 9.93972 13.667H22.0609C22.4793 13.667 22.8185 13.3312 22.8185 12.917V9.91699C22.8185 9.50278 22.4793 9.16699 22.0609 9.16699H9.93972ZM7.66699 9.91699C7.66699 8.67435 8.68453 7.66699 9.93972 7.66699H22.0609C23.3161 7.66699 24.3337 8.67435 24.3337 9.91699V12.917C24.3337 14.1596 23.3161 15.167 22.0609 15.167H9.93972C8.68453 15.167 7.66699 14.1596 7.66699 12.917V9.91699Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.93972 18.333C9.52132 18.333 9.18214 18.6688 9.18214 19.083V22.083C9.18214 22.4972 9.52132 22.833 9.93972 22.833H22.0609C22.4793 22.833 22.8185 22.4972 22.8185 22.083V19.083C22.8185 18.6688 22.4793 18.333 22.0609 18.333H9.93972ZM7.66699 19.083C7.66699 17.8404 8.68453 16.833 9.93972 16.833H22.0609C23.3161 16.833 24.3337 17.8404 24.3337 19.083V22.083C24.3337 23.3256 23.3161 24.333 22.0609 24.333H9.93972C8.68453 24.333 7.66699 23.3256 7.66699 22.083V19.083Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 11.5C11 11.2239 11.2227 11 11.4975 11H11.5025C11.7773 11 12 11.2239 12 11.5C12 11.7761 11.7773 12 11.5025 12H11.4975C11.2227 12 11 11.7761 11 11.5Z"
        fill="#29394D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 20.667C11 20.3908 11.2227 20.167 11.4975 20.167H11.5025C11.7773 20.167 12 20.3908 12 20.667C12 20.9431 11.7773 21.167 11.5025 21.167H11.4975C11.2227 21.167 11 20.9431 11 20.667Z"
        fill="#29394D"
      />
    </svg>
  );
};

export default IconSource;
